/*
 * Défi anti bot adaptatif : pont entre l'interceptor axios (lib/api.js) et
 * la modale AntiBotChallenge montée dans App.js.
 *
 * Principe : quand le backend détecte un comportement anormal (limite de
 * débit dépassée), il renvoie un 429 accompagné d'un défi signé. Le module
 * ci dessous permet à l'interceptor de demander l'affichage de la modale et
 * d'attendre sa résolution avant de rejouer la requête d'origine.
 *
 * Conformité Conservation Nulle : aucun service tiers, aucune donnée
 * personnelle, uniquement une petite question arithmétique.
 */

let challengeHandler = null;

/*
 * Enregistre le gestionnaire de défi (appelé par le composant
 * AntiBotChallenge au montage). Retourne une fonction de désenregistrement.
 */
export function setChallengeHandler(handler) {
  challengeHandler = handler;
  return () => {
    if (challengeHandler === handler) {
      challengeHandler = null;
    }
  };
}

/*
 * Demande la résolution d'un défi. Retourne une promesse qui se résout
 * quand la personne a répondu correctement, ou échoue si elle abandonne.
 */
export function requestChallengeResolution(challenge) {
  if (!challengeHandler) {
    return Promise.reject(new Error("defi_indisponible"));
  }
  return challengeHandler(challenge);
}
